module.exports = __webpack_public_path__ + "static/media/ca.pictogram.b5f5c390.svg";